import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { ErrorPage } from '../../components/StyledComponents';
import { Loading } from '../../components';
import { OrganizationQuery, useCreateProcessStepMutation, UserQuery, useTopicGroupQuery } from '../../generated/hooks';
import { SortOption, Topics } from '../../components/ConversationSubjects/Topics';
import { isPulserTopicGroup } from '../../lib/helpers/pulser';

interface IProps extends RouteComponentProps<any> {
  organization: OrganizationQuery['organization'];
  user: UserQuery['user'];
}

const AddTopicScreen = (props: IProps) => {
  const {
    match: { params },
    user,
    organization,
  } = props;
  const { t } = useTranslation('processDetail');
  const { loading, error, data } = useTopicGroupQuery({
    variables: { topicGroupId: params.topicGroupId },
    fetchPolicy: 'cache-first',
  });
  const [createProcessTopicGroup] = useCreateProcessStepMutation();
  const history = useHistory();

  if (!organization) {
    return null;
  }
  if (error) {
    return <ErrorPage>{t('common:loadError')}</ErrorPage>;
  }
  if (loading || !data) {
    return <Loading />;
  }

  const handleAddTopicToProcess = (stepTopicGroupId: string) => {
    createProcessTopicGroup({
      variables: {
        input: {
          processTopicGroupId: data.topicGroup.id!,
          stepTopicGroupId,
        },
      },
      onCompleted: (mutationData) => {
        const stepId = mutationData.createProcessStep?.id;
        if (stepId) {
          history.push(`/process/${data.topicGroup.id}?editingStep=${stepId}`);
        }
      },
    });
  };

  return (
    <Topics
      breadcrumbItems={[
        { title: t('ReportAccess:topics'), link: '/topics' },
        {
          title: data.topicGroup.name,
          link: `/process/${params.topicGroupId}`,
        },
      ]}
      heading={t('processDetail:chooseTopic')}
      dataIcom="heading-topics"
      user={user}
      hideCreateTopicButton={true}
      defaultSortOption={SortOption.UPDATED_AT_DESC}
      actionButtonText={t('processDetail:addTopic')}
      includeStepTopics={true}
      actionButtonOnClick={(tg) => {
        if (tg.id) {
          handleAddTopicToProcess(tg.id);
        }
      }}
      filterTopicGroups={(topicGroup) => !topicGroup.containsSteps && !isPulserTopicGroup(topicGroup)}
    />
  );
};

export default AddTopicScreen;
